import { render, staticRenderFns } from "./DialogUpdateRoyalties.vue?vue&type=template&id=28a720df&scoped=true"
import script from "./DialogUpdateRoyalties.vue?vue&type=script&lang=ts"
export * from "./DialogUpdateRoyalties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a720df",
  null
  
)

export default component.exports